export const RoleConstants = {
  AUXILIARY_APPLICATION_READER_ID: 1,
  TROOPER_APPLICATION_READER_ID: 2,
  ADMINISTRATOR_ID: 3,
  POLYGRAPHER_ID: 4,
  BACKGROUND_INVESTIGATOR_ID: 5,
  PAT_INSTRUCTOR_ID: 6,
  AUXILIARY_APPLICATION_REVIEWER_ID: 7,
  TROOPER_APPLICATION_REVIEWER_ID: 8,
}
